// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.common-modal {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  top: 0;
  left: 0;
  z-index: 9999;
  overflow-y: auto;
  text-align: center;
}
.common-modal img {
  height: 2em;
  margin-bottom: 1em;
}
.common-modal .common-modal-continer {
  width: 25%;
  position: relative;
  height: auto;
  background: #fff;
  border-radius: 4px;
  margin: 0 auto;
  top: 20%;
}
@media (max-width: 470px) {
  .common-modal .common-modal-continer {
    width: 100% !important;
    border-radius: 0px;
    margin: 0 auto;
    top: 0;
  }
}
.common-modal .common-modal-continer .body {
  position: relative;
  padding: 5%;
  width: 100%;
  height: 80%;
}
.common-modal .common-modal-continer .body label {
  margin: 0 0 0.9em 0;
}
.common-modal .common-modal-continer .body button {
  display: block;
  width: 100%;
}
@media (max-width: 470px) {
  .common-modal .common-modal-continer .body {
    height: auto;
  }
}
@media (max-width: 470px) {
  .common-modal .common-modal-continer .body h2 {
    font-size: 1em;
    padding: 0px 20px;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
